import { Component, OnInit } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {faCog, faCaretRight, faClose} from '@fortawesome/pro-solid-svg-icons';
import { debounceTime, of, Subscription, switchMap } from 'rxjs';
import {Meta} from "@angular/platform-browser";

@Component({
  selector: 'pmui-reset-password-view',
  templateUrl: './reset-password-view.component.html',
  styleUrls: ['./reset-password-view.component.less']
})
export class ResetPasswordViewComponent {

    requestPasswordForm: UntypedFormGroup;
    busy: boolean;
    error: '' |
        'USERNAME_MISSING' |
        'UNKNOWN_ERROR' = '';
    showTerms: boolean = false;
    faCog = faCog;
    faCaretRight = faCaretRight;
    trimSubscription: Subscription;

    constructor(
        formBuilder: UntypedFormBuilder,
        activatedRoute: ActivatedRoute,
        private httpClient: HttpClient,
        private router: Router,
        private meta: Meta
    ) {
        this.requestPasswordForm = formBuilder.group({
           username: [activatedRoute.snapshot.params.username?.trim() || '', [ Validators.required ]]
        });
    }

    ngOnDestroy() {
        this.trimSubscription.unsubscribe();
    }

    ngOnInit() {
        this.trimSubscription = this.requestPasswordForm.get('username').valueChanges.pipe(
            debounceTime(50),
            switchMap(newVal => of(newVal))
        ).subscribe((newVal) => {
            this.requestPasswordForm.get('username').setValue(newVal.trim(), {emitEvent: false});
        });

        // Set meta tags to prevent indexing
        // The robots meta tag instructs search engines not to show the page in search results
        this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
    }

    requestPasswordReset() {

        this.busy = true;
        this.error = '';

        if (!this.requestPasswordForm.value.username) {
            this.error = 'USERNAME_MISSING';
            this.busy = false;
            return;
        }

        let params = new HttpParams();

        params = params.set('username', this.requestPasswordForm.value.username);

        this.httpClient.post(environment.apiV1BaseUrl + '/accounts/users/request-password-reset', '', { params: params }).subscribe(
            (success) => {
                this.router.navigate(['/request-password-reset-success']);
            },
            (error) => {
                this.error = 'UNKNOWN_ERROR';
                this.busy = false;
            }
        )
    }

    protected readonly faClose = faClose;
}
